import { render } from "./ReportDetails.vue?vue&type=template&id=688a1e27&scoped=true"
import script from "./ReportDetails.vue?vue&type=script&lang=js"
export * from "./ReportDetails.vue?vue&type=script&lang=js"

import "./ReportDetails.vue?vue&type=style&index=0&id=688a1e27&lang=css"
import "./ReportDetails.vue?vue&type=style&index=1&id=688a1e27&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-688a1e27"]])

export default __exports__